// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__mBMBF","modal":"Modal_modal__lLcOT","closeButton":"Modal_closeButton__lY0wX"};